import "./Property.style.css";

import { ChangeEvent } from "react";
import { PropertyType } from "../../../../utils/enums/PropertyType";
import { ObjectValue } from "../../../../utils/states/ConstructorPageStates/ObjectValue";

import numberImage from "../../../../resources/images/number.png";
import textImage from "../../../../resources/images/text.png";
import imageImage from "../../../../resources/images/image.png";
import dateImage from "../../../../resources/images/date.png";
import uploadImage from "../../../../resources/images/upload.png";

interface PropertyProps {
  propertyName: string;
  objectValue: ObjectValue;
  handleChangeValue: (e: ChangeEvent<HTMLInputElement>) => void;
  inputName: string;
  handlePropertyImageUpload: (e: ChangeEvent<HTMLInputElement>) => void;
}

const typeIcons = {
  [PropertyType.Integer]: numberImage,
  [PropertyType.String]: textImage,
  [PropertyType.Image]: imageImage,
  [PropertyType.Date]: dateImage,
};

export const Property = ({
  propertyName,
  objectValue,
  inputName,
  handleChangeValue,
  handlePropertyImageUpload,
}: PropertyProps) => {
  const { type, value } = objectValue;

  const showObjectValues = () => {
    const iconSrc = typeIcons[type];

    switch (type) {
      case PropertyType.Integer:
        return (
          <div className="property__block">
            <div className="property__header">
              <img
                src={iconSrc}
                alt={`${PropertyType[type]} icon`}
                className="property__icon"
              />
              <div className="property__name header_4">{propertyName}</div>
            </div>
            <div className="property__field">
              <input
                autoComplete="off"
                type="number"
                name={inputName}
                value={value}
                onChange={handleChangeValue}
                className="property_input text_2"
              />
            </div>
          </div>
        );
      case PropertyType.String:
        return (
          <div className="property__block">
            <div className="property__header">
              <img
                src={iconSrc}
                alt={`${PropertyType[type]} icon`}
                className="property__icon"
              />
              <div className="property__name header_4">{propertyName}</div>
            </div>
            <div className="property__field">
              <input
                autoComplete="off"
                type="text"
                name={inputName}
                value={value}
                onChange={handleChangeValue}
                className="property_input text_2"
              />
            </div>
          </div>
        );
      case PropertyType.Date:
        return (
          <div className="property__block">
            <div className="property__header">
              <img
                src={iconSrc}
                alt={`${PropertyType[type]} icon`}
                className="property__icon"
              />
              <div className="property__name header_4">{propertyName}</div>
            </div>
            <div className="property__field">
              <input
                autoComplete="off"
                type="date"
                name={inputName}
                value={value}
                onChange={handleChangeValue}
                className="property_input text_2"
              />
            </div>
          </div>
        );
      case PropertyType.Image:
        return (
          <div className="property__block">
            <div className="property__header">
              <img
                src={iconSrc}
                alt={`${PropertyType[type]} icon`}
                className="property__icon"
              />
              <div className="property__name header_4">{propertyName}</div>
            </div>
            <div className="property__field">
              <input
                autoComplete="off"
                type="text"
                value={value}
                className="property_input text_2"
              />
              <label
                className="property__upload_image"
                htmlFor={`propertyImageUploadInput${inputName}`}
                style={{ cursor: "pointer", display: "block" }}
              >
                <img
                  src={uploadImage}
                  onClick={(e) => e.stopPropagation()}
                  alt="upload"
                />
              </label>
              <input
                autoComplete="off"
                id={`propertyImageUploadInput${inputName}`}
                type="file"
                onChange={handlePropertyImageUpload}
                name={inputName}
                className="constructor_table__image_input game_text"
                accept="image/*"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        );
      default:
        return <div className="property__name">{propertyName}</div>;
    }
  };

  return <div className="property_container">{showObjectValues()}</div>;
};
